export default __webpack_public_path__ + "static/media/ic-waze.246b0dfb.svg";